import { useContext, useState } from "react";

import { Box, Heading, Stack } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";

import { AgencyType } from "@/codegen/openapi2";
import { ZoneName } from "@/components/2/geo";
import { TableLayout } from "@/components/2/layouts/table";
import { LegalEntityName } from "@/components/2/legal-entity";
import { LegalEntityContext } from "@/components/2/legal-entity-context";
import { useGetAgenciesGeographiesAgenciesGet } from "@/services/2/react-query/hooks";

import { AgencyFilters, AgencyFiltersType } from "./agency-filters";

const columnHelper = createColumnHelper<AgencyType>();

const columns = [
  columnHelper.accessor("legal_entity_uuid", {
    header: "Entité",
    cell: ({ cell }) => <LegalEntityName legalEntityUuid={cell.getValue()} />,
    minSize: 150,
  }),
  columnHelper.accessor("name", { header: "Agence" }),
  columnHelper.accessor("zone_uuid", {
    header: "Zone",
    cell: ({ cell }) => <ZoneName zoneUuid={cell.getValue()} />,
    minSize: 300,
  }),
];

export const Agencies = () => {
  const legalEntityContext = useContext(LegalEntityContext);
  const [filters, setFilters] = useState<AgencyFiltersType>({});

  const queryParams = {
    legal_entity_uuids: filters.entities?.length
      ? filters.entities
      : legalEntityContext
        ? [legalEntityContext]
        : null,
    agency_uuids: filters.agencies || [],
    zone_uuids: filters.zones || [],
  };
  const { data } = useGetAgenciesGeographiesAgenciesGet(
    { query: queryParams },
    ["uncached", queryParams],
    { placeholderData: [] }
  );

  return (
    <Stack>
      <Box p={8} backgroundColor={"gray.100"}>
        <Heading size="2xl">Agences</Heading>
      </Box>

      <Stack p={8} gap={4}>
        <AgencyFilters filters={filters} setFilters={setFilters} />
        <TableLayout
          autoResetPageIndex
          data={data as AgencyType[]}
          columns={columns}
          withPagination
        />
      </Stack>
    </Stack>
  );
};
